import React, { useCallback } from "react";
import { Flex, Form, Input, message, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { SubmitButton } from "@/components/button/submit-button";
import {
  LoginResponseSchema,
  IPVerifiedSchema,
} from "@/schemas";
import { publicRequest } from "@/services";
import { useNavigate } from "react-router-dom";
import { internalIpV4 } from "internal-ip";

const onRequestSendIP = async (body: IPVerifiedSchema) => {
  try {
    const result = await publicRequest<IPVerifiedSchema, LoginResponseSchema>({
      url: "/ip-verified",
      method: "POST",
      data: body,
    });

    console.log(result);
    return result;
  } catch (error) {
    console.log(error);
  }
};

const LoginIPAddr: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = () => {
    message.success("Submit success!");
  };

  const onFinishFailed = () => {
    message.error("Submit failed!");
  };

  const onSendIP = useCallback(async () => {
    var macAddr = "";
    var ip = await internalIpV4();
    try {
      const body = {
        email: form.getFieldValue("email"),
        mac: macAddr,
        ip: ip ?? "",
      };

      const result = await onRequestSendIP(body);
      if (result?.code == "200") {
        await localStorage.setItem("token", result.data?.token ?? "");
        message.success("ログインしました。");
        navigate("/ip-verified");
      }
      else {
        message.error("Email is invalid or doesn't match any account!");
      }
    } catch (error) {
      message.error("もう一度お試しください。");
    }
  }, [form, navigate]);

  return (
    <Flex gap="middle" align="center" vertical>
      <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
        管理機能
      </Typography.Text>

      <Typography.Text style={{ fontSize: 24 }}>ログイン</Typography.Text>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          name="email"
          label="メールアドレス"
          rules={[
            { required: true, message: "メールアドレスを再入力してください" },
            { type: "email", message: "メールは無効です。" },
          ]}
        >
          <Input
            style={{ width: 360 }}
            size="large"
            type="email"
            placeholder="メールアドレスを入力してください。!"
            prefix={<UserOutlined />}
          />
        </Form.Item>
      </Form>
      <Form.Item>
        <SubmitButton
          onClick={onSendIP}
          styles={{ width: 360 }}
          form={form}
          title={"ログイン"}
        />
      </Form.Item>
    </Flex>
  );
};

export default LoginIPAddr;
